// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"blog-button-module--wrapper--1Buqo","blog__button":"blog-button-module--blog__button--3NSNz","prev":"blog-button-module--prev--23cRX"};